import { useState } from 'react';
import { createPortal } from 'react-dom';
import OriLanding from './components/OriLanding';
import MessageOriModal from './components/MessageOriModal';
import OriPrivacyPolicy from './pages/ori/OriPrivacyPolicy';
import OriTermsOfService from './pages/ori/OriTermsOfService';
import CommunityGuidelines from './pages/CommunityGuidelines';
import AboutUs from './pages/AboutUs';
import { initUiTracking } from './telemetry/ui-tracking';
import { CookieBanner } from '../../shared-web/CookieBanner';

function renderPage(rawPath: string) {
  // Vite serves this app under /marketing/ in local development, while the
  // production server mounts it at /. Normalize both so concept and legal
  // routes behave identically in preview and production.
  const path = rawPath === '/marketing'
    ? '/'
    : rawPath.startsWith('/marketing/')
      ? rawPath.slice('/marketing'.length)
      : rawPath;
  if (path === '/privacy' || path === '/privacy-policy') return <OriPrivacyPolicy />;
  if (path === '/terms' || path === '/terms-of-service') return <OriTermsOfService />;
  if (path === '/ori/privacy' || path === '/ori/privacy-policy') return <OriPrivacyPolicy />;
  if (path === '/ori/terms' || path === '/ori/terms-of-service') return <OriTermsOfService />;
  if (path === '/community-guidelines') return <CommunityGuidelines />;
  if (path === '/about-us' || path === '/about') return <AboutUs />;
  return null;
}

// `path` is passed in rather than read from window here: this component is
// rendered on the server by scripts/prerender-marketing.mjs, where there is no
// window at all. The browser entry (main.tsx) supplies location.pathname.
export default function App({ path }: { path: string }) {
  const [messageOriOpen, setMessageOriOpen] = useState(false);
  const page = renderPage(path);

  return (
    <>
      {page ?? <OriLanding onMessageOri={() => setMessageOriOpen(true)} />}
      {messageOriOpen &&
        createPortal(
          <MessageOriModal mode="message" onClose={() => setMessageOriOpen(false)} />,
          document.body,
        )}
      <CookieBanner
        compact
        onAccept={() => {
          // The visitor just opted in — start the ad pixels (defined by the
          // index.html head snippet) and PostHog without a reload.
          window.__oriLoadAdPixels?.();
          initUiTracking();
        }}
      />
    </>
  );
}
